/* eslint-disable no-undef */
/**
 * AuthUtils.js
 *
 * Provide utilities for authentication flow.
 */
import * as Cookies from 'es-cookie';
import decode from 'jwt-decode';
import logger from 'js-logger';

/**
 *
 * Constant: USER_TOKEN_KEY
 *
 * The user token key persisted on session of the logged user.
 */
const USER_TOKEN_KEY = 'user_token';

/**
 * Create or replace a user token on session storage.
 * @param token
 */
export const createOrReplaceUserToken = (token) => {
  if (typeof window === 'undefined') return;
  try {
    Cookies.set(USER_TOKEN_KEY, token);
  } catch (error) {
    logger.error('Could not set user token cookie', error.message);
  }
  try {
    localStorage.setItem(USER_TOKEN_KEY, token);
  } catch (error) {
    logger.error('Could not set user token localstorage', error.message);
  }
};

/**
 * Remove an user token persisted on session storage.
 */
export const removeUserToken = () => {
  if (typeof window === 'undefined') return;
  try {
    Cookies.remove(USER_TOKEN_KEY);
  } catch (error) {
    logger.error('Could not remove user token from cookie', error.message);
  }
  try {
    localStorage.removeItem(USER_TOKEN_KEY);
  } catch (error) {
    logger.error('Could not remove user token from localstorage', error.message);
  }
};

/**
 * Verify expires date of token
 * @param boolean
 */
export const isTokenExpired = (token) => {
  if (typeof window === 'undefined') return null;
  const decoded = token ? decode(token) : {};
  return token ? (decoded.exp < Date.now() / 1000) : true;
};

/**
 * Obtain the user token persisted on session storage.
 * @returns {string | null}
 */
export const getUserToken = () => {
  if (typeof window !== 'undefined') {
    let token = null;
    try {
      token = Cookies.get(USER_TOKEN_KEY);
    } catch (error) {
      logger.error('Could not get user token from cookie', error.message);
    }
    try {
      if (!token) token = localStorage.getItem(USER_TOKEN_KEY);
    } catch (error) {
      logger.error('Could not get user token from localstorage', error.message);
    }

    if (isTokenExpired(token)) {
      removeUserToken();
      return null;
    }
    return token;
  }
  return null;
};
